module.exports = __webpack_public_path__ + "static/09-e17b90fc4e09123095046467e396ea59.jpg";